import throttle from 'lodash/throttle';

export const loadState = () => {
  try{
    const serializedState = localStorage.getItem('state');
    if (serializedState == null) {
      return null;
    }
    else {
      return JSON.parse(serializedState);
    }
  }
  catch(e){
    return null;
  }
};

export const saveState = (state) => {
  //console.log('Se guarda en local: ', state);
  
  try{
    const serializedState = JSON.stringify(state);
    localStorage.setItem('state',serializedState);
  }catch(e){
    console.log(e);
  }
}

export const persistStore = store =>
  store.subscribe(throttle(() => saveState(store.getState()), 10000));
